
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as ModelPrincipal } from '../../controlador';
    import { Controlador as Model } from './controlador';
    import { Categoria } from '@/__env/lib/Web/Categorias';
    import { Wait } from '@/__env/ext';
    import { Utiles } from '@/__env/pluggins/event-bus';
    //import buscador from './lista-buscador.vue';
    //import tipos from './lista-buscador-tipos.vue';
    //import listado from './lista-listado.vue';
    @Component( {
        name: "Componente",
        props: {},
        components: {
            //      buscador,
            //      listado,
            //      tipos,
        }
    } )
    export default class Componente extends Vue
    {
        public get Principal() { return Vue.observable( ModelPrincipal ); }
        public get Controlador() { return Vue.observable( Model ); }
        public get Buscador() { return this.Controlador.Buscador; }
        public get Estado() { return this.Controlador.Buscador.Estado; }

        public Seleccionado: number = null;
        public Nueva: string = '';
        public Busqueda: string = '';
        public Filtrados: Categoria[] = [];
        @Watch( 'Busqueda' )
        async onBusqueda()
        {
            if ( this.Busqueda )
            {
            

            } else
            {
                this.Filtrados.clear();
            }
        }

        async onBuscar()
        {
            let bb = this.Busqueda;
            await Wait( 100 );

            if ( bb == this.Busqueda )
            {
                this.Filtrados = this.Buscador.Items.filter( x => x.Descripcion.toLowerCase().includes( this.Busqueda.toLowerCase() ) );
            }
        }

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }

        mounted()
        {
            this.Controlador.Buscador.Filtros.set( this.$route.query );
            this.Controlador.Buscador.Buscar();

        }


        public async Atras()
        {
            if ( this.Controlador.Historial.hasRows() )
            {
                this.Controlador.Seleccionado = this.Controlador.Historial.pop();
                this.Buscador.Filtros.Padre = this.Controlador.Seleccionado.Id;
            } else
            {
                this.Controlador.Seleccionado = null;
                this.Buscador.Filtros.Padre = null;
            }

            this.Filtrados.clear();
            await this.Buscador.Buscar();
        }

        public async Abrir( catego: Categoria )
        {
            if ( this.Controlador.Seleccionado )
                this.Controlador.Historial.push( this.Controlador.Seleccionado );

            this.Controlador.Seleccionado = catego;
            this.Buscador.Filtros.Padre = catego.Id;
            this.Filtrados.clear();
            await this.Buscador.Buscar();
            
        }

        public async Guardar()
        {
            if ( this.Nueva && this.Nueva.length >= 3 )
            {


                let cc = new Categoria();
                cc.Id = 0;
                cc.Descripcion = this.Nueva;
                if ( this.Controlador.Seleccionado && this.Controlador.Seleccionado.Existe )
                {
                    cc.Padre = this.Controlador.Seleccionado;
                }

                if ( await cc.save() )
                {
                    Utiles.Notificaciones.Completado( 'Guardado!' );
                    this.Nueva = '';
                    this.Buscador.Items.unshift( cc );
                }
                else
                {
                    Utiles.Notificaciones.Error( 'Error al guardar' );
                }



            }
        }

        public async Actualizar( catego: Categoria )
        {
            if ( catego.DescripcionNueva && catego.DescripcionNueva.length >= 3 && catego.DescripcionNueva != catego.Descripcion )
            {
                catego.Descripcion = catego.DescripcionNueva;


                if ( await catego.save() )
                {
                    Utiles.Notificaciones.Completado( 'Actualizada!' );
                    catego.DescripcionNueva = catego.Descripcion;
                }
                else
                {
                    Utiles.Notificaciones.Error( 'Error al guardar' );
                }



            }
        }

    }
